<template>
  <div>
    <luci-btn-icon :config="backBtnConfig" @callback="$router.push({ name: 'BrandList' })"></luci-btn-icon>

    <v-alert v-if="error" :value="true" color="error" icon="error" class="error-container">
      <span class="error-span luci-text white--text">{{ error }}</span>
    </v-alert>

    <div v-if="isLoading" class="loading">
      <img src="../../assets/images/icons/loading-pmc.gif" alt="'Loading">
    </div>

    <div v-if="!isLoading">
      <luci-form :config="formConfig" v-model="formData" @submit="submitForm" @reset="resetForm" @callback="$router.push({ name: 'BrandList' })" ></luci-form>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import variables from '../../helpers/variables'

const { mapGetters, mapActions } = createNamespacedHelpers('brand/create')

export default {
  data () {
    return {
      backBtnConfig: variables.backBtnIconOptions,
      formData: { name: '', description: '' }
    }
  },
  computed: {
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ]),
    formConfig () {
      return (
        {
          name: 'form-add-brand',
          title: 'Details',
          description: 'To add a new brand please fill in the form below',
          showButtonAsIcon: true,
          buttons: variables.formButtons,
          fields: [
            {
              order: 1,
              element: 'input',
              required: true,
              name: 'name',
              label: 'name',
              inputConfig: { type: 'text', placeholder: 'Please enter brand name', clearable: true }
            },
            {
              order: 2,
              element: 'textarea',
              required: true,
              name: 'description',
              label: 'description',
              textareaConfig: { placeholder: 'Please enter brand description', clearable: true }
            }
          ]
        }
      )
    }
  },
  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      this.$router.push({ name: 'BrandList' })
    }
  },
  created () {
    this.reset()
  },
  methods: {
    ...mapActions([
      'reset',
      'create'
    ]),
    resetForm () {
      this.reset()
      this.formData = { name: '', description: '' }
    },
    submitForm () {
      this.create(this.formData)
    }
  }
}
</script>
